// eslint-disable-next-line no-unused-vars
import React from "react";
import styles from "./WarningPopup.module.css";
import CloseModal from "../../assets/images/close_modal.js";

export default function WarningPopup({ isOpen, setIsOpen }) {
  return (
    <div className={`${styles.popup} ${isOpen ? styles.open : null}`}>
      <div className={styles.contentWrapper}>
        <div className={styles.close} onClick={() => setIsOpen(false)}>
          <CloseModal />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>IMPORTANT SAFETY INFORMATION</div>
          <div className={styles.text}>
            <div className={styles.bold}>Indication</div>
            <br />
            GIAPREZA (angiotensin II) increases blood pressure in adults with
            septic or other distributive shock.
            <br />
            <br />
            <div className={styles.bold}>Contraindications</div>
            <br />
            None
            <br />
            <br />
            <div className={styles.bold}>Warnings and Precautions</div>
            <br />
            The safety of GIAPREZA was evaluated in 321 adults with septic or
            other distributive shock in a randomized, double-blind,
            placebo-controlled study, ATHOS-3. There was a higher incidence of
            arterial and venous thrombotic and thromboembolic events in patients
            who received GIAPREZA compared to placebo-treated patients in the
            ATHOS-3 study (13% vs. 5%). The major imbalance was in deep venous
            thromboses. Use concurrent venous thromboembolism (VTE) prophylaxis.{" "}
            <br />
            <br />
            <div className={styles.bold}>Adverse Reactions</div>
            <br />
            The most common adverse reactions reported in greater than 10% of
            GIAPREZA-treated patients were thromboembolic events. Adverse
            reactions occurring in ≥4% of patients treated with GIAPREZA and
            ≥1.5% more often than placebo-treated patients in the ATHOS-3 study
            were thromboembolic events (including deep vein thrombosis),
            thrombocytopenia, tachycardia, fungal infection, delirium, acidosis,
            hyperglycemia, and peripheral ischemia. <br />
            <br />
            <div className={styles.bold}>Drug Interactions​</div>
            <br />
            Angiotensin converting enzyme (ACE) inhibitors may increase response
            to GIAPREZA. Angiotensin II receptor blockers (ARBs) may reduce
            response to GIAPREZA.
            <br />
            <br />
            <div className={styles.bold}>
              You are encouraged to report negative side effects of prescription
              drugs to the FDA. To report SUSPECTED ADVERSE REACTIONS, please
              contact:
            </div>
            <br />
            La Jolla Pharmaceutical Company
            <br />
            <a href="tel:1-800-651-3861">1-800-651-3861</a>
            <br />
            <a href="mailto:medicalinformation@ljpc.com">
              medicalinformation@ljpc.com
            </a>
            <br />
            <br />
            U.S. Food and Drug Administration
            <br />
            <a href="tel:1-800-332-1088">1-800-FDA-1088</a>
            <br />
            <a
              href="http://www.fda.gov/medwatch"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.fda.gov/medwatch
            </a>
            <br />
            <br />
            <span className={styles.bold}>
              For additional information, please see
            </span>{" "}
            <a
              href="https://firebasestorage.googleapis.com/v0/b/giapreza-db.appspot.com/o/prescribing%2FGIAPREZA.pdf?alt=media"
              target="_blank"
              rel="noopener noreferrer"
            >
              GIAPREZA FDA prescribing information
            </a>
            .
          </div>
        </div>
      </div>
    </div>
  );
}
